// Modules
import {useNavigate} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'app/store';
import { clearAuth } from 'features/auth/authSlice';

// UI
import {Button} from 'components/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from 'components/catalyst/dialog';
import {Text} from 'components/catalyst/text';

interface Props {
  isOpen: boolean;
  handleCloseModal: () => void;
  navigateTo?: string;
}

const LogoutModal = ({isOpen, handleCloseModal, navigateTo}: Props) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('common');

  const handleLogout = () => {
    dispatch(clearAuth());

    navigate(navigateTo ?? '/login');

    handleCloseModal();
  };

  return (
    <Dialog open={isOpen} onClose={handleCloseModal}>
      <DialogTitle>{t('LOGOUT_MODAL_TITLE')}</DialogTitle>

      <DialogBody>
        <Text>{t('LOGOUT_MODAL_MESSAGE')}</Text>
      </DialogBody>

      <DialogActions>
        <Button plain onClick={handleCloseModal} className="cursor-pointer">
          {t('LOGOUT_MODAL_CANCEL_BUTTON')}
        </Button>

        <Button onClick={handleLogout} color="rose" className="cursor-pointer">
          {t('LOGOUT_MODAL_CONFIRM_BUTTON')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutModal;
